import { plural } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { NoddiButton, NoddiDialog } from 'noddi-ui-web';

import './fireworks.css';

type Props = {
  open: boolean;
  onClose: () => void;
  count: number;
};

export const AcceptSuccessDialog = ({ open, onClose, count }: Props) => (
  <NoddiDialog
    open={open}
    onClose={onClose}
    maxWidth='sm'
    showCloseButton
    footer={
      <div className='flex justify-center'>
        <NoddiButton onClick={onClose}>
          <Trans>Got it</Trans>
        </NoddiButton>
      </div>
    }
  >
    <div className='flex flex-col items-center gap-5 py-4'>
      {open && (
        <div className='fireworks-container'>
          {Array.from({ length: 12 }).map((_, i) => (
            <div key={i} className='firework' style={{ '--i': i } as React.CSSProperties} />
          ))}
        </div>
      )}
      {/* eslint-disable-next-line noddi/no-emoji-in-ui -- deliberate emoji in customer-facing copy: it carries the tone of the message, it is not a status a NoddiIcon could show */}
      <div className='text-6xl'>🎉</div>
      <div className='flex flex-col items-center gap-2 text-center'>
        <h2 className='text-2xl font-semibold'>
          {plural(count, { one: '# offer accepted!', other: '# offers accepted!' })}
        </h2>
        <p className='text-muted-foreground'>
          {plural(count, {
            one: "We'll order this set from our supplier today and keep you posted as it ships and gets mounted.",
            other:
              "We'll order these tire sets from our supplier today and keep you posted as they ship and get mounted."
          })}
        </p>
      </div>
    </div>
  </NoddiDialog>
);
